module.exports = __webpack_public_path__ + "OpenSans-SemiboldItalic-3343e54368719e3786f78a1b22839455.woff2";